import React, { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import bg from "../assets/bg.png";
import bg0 from "../assets/bg0.jpeg";

const Header = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    setIsLoaded(true);
    
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Container id="header">
      <BackgroundImage style={{ transform: `translateY(${scrollY * 0.5}px)` }} />
      <Overlay />
      <ParticlesContainer>
        {[...Array(20)].map((_, i) => (
          <Particle key={i} style={{ 
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${3 + Math.random() * 4}s`
          }} />
        ))}
      </ParticlesContainer>
      
      <Conteudo>
        <ContainerTexto $isLoaded={isLoaded}>
          <SubtitleBadge>
            <BadgeGlow />
            <span>💪 TRANSFORME SUA VIDA</span>
          </SubtitleBadge>
          <Titulo>
            <TituloLine $delay="0.3s">HOJE É O</TituloLine>
            <TituloLine $delay="0.5s"><HighlightText>MELHOR DIA</HighlightText></TituloLine>
            <TituloLine $delay="0.7s">PARA COMEÇAR</TituloLine>
          </Titulo>
          <Descricao>
            Descubra o poder de superar seus limites. Na M30 Fitness, 
            oferecemos a estrutura e o suporte que você precisa para 
            alcançar seus objetivos.
          </Descricao>
          <ButtonGroup>
            <PrimaryButton href="#precos">
              <ButtonShine />
              <span>COMECE AGORA</span>
            </PrimaryButton>
            <SecondaryButton href="#servicos">
              <span>SAIBA MAIS</span>
              <ArrowIcon>→</ArrowIcon>
            </SecondaryButton>
          </ButtonGroup>
          <StatsContainer>
            <StatItem>
              <StatNumber>1000+</StatNumber>
              <StatLabel>Alunos Satisfeitos</StatLabel>
            </StatItem>
            <StatDivider />
            <StatItem>
              <StatNumber>4+</StatNumber>
              <StatLabel>Anos de História</StatLabel>
            </StatItem>
            <StatDivider />
            <StatItem>
              <StatNumber>4</StatNumber>
              <StatLabel>Modalidades de Aulas</StatLabel>
            </StatItem>
          </StatsContainer>
        </ContainerTexto>
        
        <ContainerImagem $isLoaded={isLoaded}>
          <ImageGlowRing />
          <ImageContainer>
            <Imagem src={bg} alt="Fitness" />
          </ImageContainer>
          <FloatingBadge $position="top-right">
            <BadgeIcon>🔥</BadgeIcon>
            <BadgeText>RESULTADO GARANTIDO</BadgeText>
          </FloatingBadge>
          <FloatingBadge $position="bottom-left">
            <BadgeIcon>⚡</BadgeIcon>
            <BadgeText>TREINO PERSONALIZADO</BadgeText>
          </FloatingBadge>
        </ContainerImagem>
      </Conteudo>
      
      <ScrollIndicator href="#servicos">
        <ScrollMouse>
          <ScrollWheel />
        </ScrollMouse>
        <ScrollText>Role para explorar</ScrollText>
      </ScrollIndicator>
    </Container>
  );
};

export default Header;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(60px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-15px) rotate(2deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
`;

const scrollBounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(10px);
  }
`;

const wheelScroll = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(15px);
  }
`;

const shine = keyframes`
  0% {
    left: -100%;
  }
  50%, 100% {
    left: 100%;
  }
`;

const particleFloat = keyframes`
  0%, 100% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100vh) rotate(720deg);
    opacity: 0;
  }
`;

const glowPulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 20px var(--primary-glow), 0 0 40px var(--primary-glow);
  }
  50% {
    box-shadow: 0 0 40px var(--primary-glow), 0 0 80px var(--primary-glow);
  }
`;

const Container = styled.header`
  width: 100%;
  min-height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding-top: 80px;
`;

const BackgroundImage = styled.div`
  position: absolute;
  inset: -50px;
  background-image: url(${bg0});
  background-size: cover;
  background-position: center;
  filter: blur(2px);
  z-index: 0;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(10, 10, 10, 0.95) 0%,
    rgba(10, 10, 10, 0.8) 50%,
    rgba(10, 10, 10, 0.9) 100%
  );
  z-index: 1;
`;

const ParticlesContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  overflow: hidden;
  pointer-events: none;
`;

const Particle = styled.div`
  position: absolute;
  width: 4px;
  height: 4px;
  background: var(--primary-color);
  border-radius: 50%;
  animation: ${particleFloat} 8s ease-in-out infinite;
  box-shadow: 0 0 10px var(--primary-color);
`;

const Conteudo = styled.div`
  width: 90%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 3;
  gap: 40px;

  @media (max-width: 900px) {
    flex-direction: column;
    text-align: center;
    gap: 30px;
    padding: 20px 0;
  }
`;

const ContainerTexto = styled.div`
  display: flex;
  flex-direction: column;
  width: 55%;
  opacity: 0;
  
  ${({ $isLoaded }) => $isLoaded && css`
    animation: ${fadeInUp} 1s ease forwards;
  `}

  @media (max-width: 900px) {
    width: 100%;
    align-items: center;
  }
`;

const SubtitleBadge = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  background: rgba(229, 168, 0, 0.1);
  border: 1px solid rgba(229, 168, 0, 0.3);
  border-radius: 50px;
  padding: 8px 20px;
  margin-bottom: 25px;
  width: fit-content;
  overflow: hidden;

  span {
    font-family: 'Rajdhani', sans-serif;
    font-weight: 600;
    font-size: 0.9rem;
    color: var(--primary-color);
    letter-spacing: 2px;
  }
`;

const BadgeGlow = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent, rgba(229, 168, 0, 0.2), transparent);
  animation: ${shine} 3s ease-in-out infinite;
`;

const Titulo = styled.h1`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
`;

const TituloLine = styled.span`
  font-size: clamp(2.5rem, 5vw, 4.5rem);
  color: #fff;
  font-family: "Orbitron", sans-serif;
  font-weight: 800;
  line-height: 1.1;
  text-transform: uppercase;
  letter-spacing: 2px;
  opacity: 0;
  animation: ${fadeInUp} 0.8s ease forwards;
  animation-delay: ${({ $delay }) => $delay || '0s'};

  @media (max-width: 768px) {
    font-size: clamp(1.8rem, 8vw, 2.5rem);
  }
`;

const HighlightText = styled.span`
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: none;
`;

const Descricao = styled.p`
  font-family: 'Rajdhani', sans-serif;
  font-size: 1.15rem;
  color: #aaa;
  line-height: 1.8;
  margin-bottom: 35px;
  max-width: 500px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 50px;

  @media (max-width: 500px) {
    flex-direction: column;
    width: 100%;
  }
`;

const PrimaryButton = styled.a`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--gradient-primary);
  color: #000;
  padding: 18px 40px;
  border-radius: 50px;
  font-family: 'Orbitron', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  text-decoration: none;
  letter-spacing: 1px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px var(--primary-glow);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 50px var(--primary-glow);
  }

  span {
    position: relative;
    z-index: 2;
  }

  @media (max-width: 500px) {
    width: 100%;
  }
`;

const ButtonShine = styled.div`
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: ${shine} 3s ease-in-out infinite;
`;

const SecondaryButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: transparent;
  color: #fff;
  padding: 18px 35px;
  border-radius: 50px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  font-family: 'Rajdhani', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 1px;
  transition: all 0.3s ease;

  &:hover {
    border-color: var(--primary-color);
    color: var(--primary-color);
    transform: translateY(-3px);
  }

  @media (max-width: 500px) {
    width: 100%;
  }
`;

const ArrowIcon = styled.span`
  transition: transform 0.3s ease;
  
  ${SecondaryButton}:hover & {
    transform: translateX(5px);
  }
`;

const StatsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const StatItem = styled.div`
  text-align: left;

  @media (max-width: 900px) {
    text-align: center;
  }
`;

const StatNumber = styled.div`
  font-family: 'Orbitron', sans-serif;
  font-size: 2rem;
  font-weight: 800;
  color: var(--primary-color);
  margin-bottom: 5px;
`;

const StatLabel = styled.div`
  font-family: 'Rajdhani', sans-serif;
  font-size: 0.9rem;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const StatDivider = styled.div`
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);

  @media (max-width: 600px) {
    width: 50px;
    height: 1px;
  }
`;

const ContainerImagem = styled.div`
  width: 40%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  
  ${({ $isLoaded }) => $isLoaded && css`
    animation: ${fadeInRight} 1s ease 0.5s forwards;
  `}

  @media (max-width: 900px) {
    width: 80%;
    max-width: 400px;
  }
`;

const ImageGlowRing = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent;
  background: linear-gradient(var(--bg-dark), var(--bg-dark)) padding-box,
              var(--gradient-primary) border-box;
  animation: ${pulse} 3s ease-in-out infinite;
  filter: blur(20px);
`;

const ImageContainer = styled.div`
  position: relative;
  animation: ${float} 6s ease-in-out infinite;
`;

const Imagem = styled.img`
  width: 100%;
  max-width: 450px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.5));
`;

const FloatingBadge = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(20, 20, 20, 0.9);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(229, 168, 0, 0.3);
  border-radius: 15px;
  padding: 12px 18px;
  animation: ${float} 4s ease-in-out infinite;
  
  ${({ $position }) => $position === 'top-right' && css`
    top: 10%;
    right: -10%;
    animation-delay: 0.5s;
    
    @media (max-width: 900px) {
      right: 0;
      top: -5%;
    }
  `}
  
  ${({ $position }) => $position === 'bottom-left' && css`
    bottom: 15%;
    left: -15%;
    animation-delay: 1s;
    
    @media (max-width: 900px) {
      left: 0;
      bottom: 0;
    }
  `}
`;

const BadgeIcon = styled.span`
  font-size: 1.5rem;
`;

const BadgeText = styled.span`
  font-family: 'Rajdhani', sans-serif;
  font-weight: 600;
  font-size: 0.75rem;
  color: #fff;
  letter-spacing: 1px;
`;

const ScrollIndicator = styled.a`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  z-index: 3;
  animation: ${scrollBounce} 2s ease-in-out infinite;
  cursor: pointer;

  @media (max-width: 768px) {
    display: none;
  }
`;

const ScrollMouse = styled.div`
  width: 25px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  display: flex;
  justify-content: center;
  padding-top: 8px;
`;

const ScrollWheel = styled.div`
  width: 4px;
  height: 8px;
  background: var(--primary-color);
  border-radius: 2px;
  animation: ${wheelScroll} 1.5s ease-in-out infinite;
`;

const ScrollText = styled.span`
  font-family: 'Rajdhani', sans-serif;
  font-size: 0.8rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 2px;
`;
